import { MyLink } from '@app/components/ui-kit/Link';
import { useAppSelector } from '@app/redux/hooks';
import classNames from 'classnames';
import IconCart from './cart-icon.svg';

import styles from './CartBlock.module.scss';

export const CartBlock = () => {
  const { cartList } = useAppSelector(state => state.productManagement);
  return (
    <MyLink className={styles.Wrapper} href={'/basket/'}>
      <div className={classNames(styles.Container, !!cartList.length && styles.Active)}>
        <IconCart width={20} height={16} />
        {!!cartList.length && <span>{cartList.length}</span>}
      </div>
    </MyLink>
  );
};
